export default __webpack_public_path__ + "static/media/setacarrinho.6d95086e.svg";